import React, {useState} from 'react';
import {Query} from "@syncfusion/ej2-data";
import {useTranslation} from "react-i18next";
import GridTab from "../../../../../ui/components/Grid/GridTab/GridTab";
import GridTabSection, {
    GridTabSectionType
} from "../../../../../ui/components/Grid/GridTab/GridTabSection/GridTabSection";
import GridTabItem from "../../../../../ui/components/Grid/GridTab/GridTabItem/GridTabItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import Loader from "../../../../../ui/components/Loader/Loader";
import GridComponent from "../../../../../ui/components/Grid/GridComponent";
import {ColumnDirective, ColumnsDirective, Filter, Inject, Page, Sort} from "@syncfusion/ej2-react-grids";

const VideoCamerasGrid = ({orgId}) => {
    const [query] = useState(new Query().addParams('orgId', orgId));
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const {t} = useTranslation();

    const onTabItemClick = ({id}) => {
        if (id) {
            if (id === 'refresh-btn') {
                setRefreshTrigger(prev => prev + 1);
            }
        }
    }

    return (
        <>
            <GridTab onClick={onTabItemClick}>
                <GridTabSection type={GridTabSectionType.Button}>
                    <GridTabItem id='refresh-btn'
                                 text={t("btn.refresh")}
                                 icon={<FontAwesomeIcon icon={faRefresh}/>}>

                    </GridTabItem>
                </GridTabSection>
            </GridTab>
            {
                !query
                    ? <Loader/>
                    : <GridComponent id='grid'
                                     container='.video-container'
                                     url='/api/videocamera/getVideoCameras'
                                     query={query}
                                     heightMinus={2}
                                     refresh={refreshTrigger}
                                     allowFiltering={false}>
                        <ColumnsDirective>
                            <ColumnDirective field='id'
                                             visible={false}
                                             textAlign="center"
                                             isPrimaryKey={true}
                                             type='number'/>
                            <ColumnDirective field='name'
                                             headerText={t("user.form.cameras")}
                                             width='200'
                                             textAlign="left"/>
                            <ColumnDirective field='url'
                                             headerText={t("userLog.grid.url")}
                                             width='500'
                                             textAlign="center"/>

                        </ColumnsDirective>
                        <Inject services={[Page, Sort, Filter]}/>
                    </GridComponent>
            }
        </>
    );
};

export default VideoCamerasGrid;
